import apiClient from "api/api-client";
import { QUERY_KEYS } from "constants/query-keys";
import { useList } from "hooks/use-list";
import { ApiListResponse } from "types/api";
import { PublicSpecialistLicenseAndStamp } from "types/specialist-license-and-stamp";

export const usePublicSpecialistLicensesAndStamps = () => {
  return useList<PublicSpecialistLicenseAndStamp>({
    keys: [QUERY_KEYS.publicSpecialistLicensesAndStamps],
    queryFn: async ({ offset, limit, filters }) => {
      return apiClient.get<ApiListResponse<PublicSpecialistLicenseAndStamp>>("/external/specialist-licenses-and-stamps", {
        params: { offset, limit, ...filters },
      });
    },
  });
};
